import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Layout from '@opendoor/bricks/deprecated/UNSAFE_layout/Layout';
import queryString from 'querystring';

import { SIGN_UP_ROUTE } from '../routes';
import { IPageConfig, pages, startPage } from './Pages';

type SignUpProps = {
  match: {
    params: {
      slug?: string;
    };
  };
  location: {
    search: string;
  };
};

type SignUpState = {
  email?: string;
  partnershipType?: string;
  role?: string;
  partnerIdentifier?: string;
};

type QueryParams = {
  email?: string;
  partnershipType?: string;
  role?: string;
  partnerIdentifier?: string;
};

class SignUp extends React.Component<SignUpProps, SignUpState> {
  public constructor(props: SignUpProps) {
    super(props);
    const params: QueryParams = queryString.parse(this.props.location.search.substring(1));
    this.state = {
      email: params.email,
      partnershipType: params.partnershipType,
      role: params.role,
      partnerIdentifier: params.partnerIdentifier,
    };
  }

  public render() {
    return (
      <Layout headerType="HIDE_NAV" footerType="NONE">
        {this.renderRoutes()}
      </Layout>
    );
  }

  public renderRoutes = () => {
    const { email, partnershipType, role, partnerIdentifier } = this.state;
    return (
      <Switch>
        <Redirect
          exact
          from={SIGN_UP_ROUTE}
          to={{
            pathname: SIGN_UP_ROUTE + startPage.link,
            state: { email, partnershipType, role, partnerIdentifier },
          }}
        />
        {pages.map((page: IPageConfig) => (
          <Route
            key={page.path}
            exact
            path={SIGN_UP_ROUTE + page.link}
            component={page.component}
          />
        ))}
      </Switch>
    );
  };
}

export default SignUp;
